module.exports = __webpack_public_path__ + "static/media/CLIENTE.510f478a.mp4";